module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/path-to-regexp/node_modules/isarray/index.js
// module id = 493
// module chunks = 99